import api from './api'

const notificationService = {
    get_notifications(payload) {
        return api.put('/alert_notifications/get_notifications', payload)
    },
    mark_seen(payload) {
        return api.put('/alert_notifications/mark_seen', payload)
    },
}

export default notificationService
